import React from 'react';
import Reaction from './Reaction';
import { ReactComponent as LikeIcon } from '../../../../resource/LikeIcon.svg';
import { ReactComponent as DislikeIcon } from '../../../../resource/DislikeIcon.svg';
// import { ReactComponent as HeartIcon } from '../../../../resource/HeartIcon.svg';
import styles from './ReactionList.module.scss';

const catalogMap = new Map([
  [1, ({ className }) => <LikeIcon className={className} />],
  [2, ({ className }) => <DislikeIcon className={className} />],
  // [3, ({ className }) => <HeartIcon className={className} />],
]);

const ReactionList = ({ reactions }) => {
  return (
    <ul className={styles.root}>
      {reactions
        .filter((reaction) => catalogMap.has(reaction.reactionId))
        .map((reaction) => (
          <Reaction
            key={reaction.reactionId}
            renderIcon={catalogMap.get(reaction.reactionId)}
            count={reaction.count}
          />
        ))}
    </ul>
  );
};

export default ReactionList;
